export default {
  checkAccessRights: (state) => (permissions) => {
    return state.userRoles.some(r => permissions.includes(r))
  },

  checkIsAdminInTenant: (state) => (tenantId) => {
    return state.userData.admins ? state.userData.admins.map(tenant => tenant.tenant_id).includes(tenantId) : false
  }
}
